import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminUsersLayer from "../components/AdminUsersLayer";

const AdminUsersPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Admin Users" />
      <AdminUsersLayer />
    </MasterLayout>
  );
};

export default AdminUsersPage;
